import { cloudDB } from './firebaseSetup';



const getAllData = (uid) => {
    return new Promise((resolve, reject) => {
        // Get All data from firebase
        cloudDB.ref('users/'+uid).once('value', function(snapshot) {
            if(!snapshot.val()) resolve([]);
            else resolve(Object.values(snapshot.val()));
        })
    })
}

const getNotebook = (uid, slug) => {
    return cloudDB.ref(`users/${uid}/${slug}`).once('value')
        .then(snapshot => {
            let res = {...snapshot.val()};
            delete res.user;
            return res;
        })
}

const deleteNotebook = (uid, slug) => {
    // Delete Notebook from firebase
    return cloudDB.ref(`users/${uid}/${slug}`).remove();
}

const addNotebook = (user, slug, data) => {
    // Add Notebook to Firebase
    return cloudDB.ref(`users/${user.uid}/${slug}`)
        .set({
            ...data,
            user
        })

}
const setAutoSave = (uid, slug, toEnableAutoSave = false) => {
    return cloudDB.ref(`users/${uid}/${slug}`)
        .update({
            autoSave: toEnableAutoSave,
            timestamp: Math.floor((new Date()).getTime() / 1000)
        });
}

const addContent = (uid, slug, content) => {
    // .update returns a promise
    return cloudDB.ref(`users/${uid}/${slug}`)
        .update({
            content: content,
            timestamp: Math.floor((new Date()).getTime() / 1000)
        });
}


const getAddressToBookNode = (username, slug) => {
    return cloudDB.ref(`public/${username}`).once('value')
        .then(snapshot => {
            let node = snapshot.val();
            if(!node) throw new Error("Notebook not found");
            return node.path + '/' + slug;
        })
        .then(path => cloudDB.ref(`users/${path}`).once('value'))
        .then(snapshot =>  snapshot.val());
}

const getUsername = (uid) => {
    return cloudDB.ref('public')
        .orderByChild('path')
        .equalTo(uid)
        .once('value')
        .then(snapshot => {
            if(!snapshot.val()) return;
            return Object.keys(snapshot.val())[0];
        })
}


const makeShareable = (user, slug) => {
    return getUsername(user.uid)
        .then(username => {
            if(!username) username = user.email.split('@')[0].replace(/\.|_/g, '') + (new Date().getTime().toString().slice(-4));
            return cloudDB.ref(`users/${user.uid}/${slug}`)
                .update({
                    sharedWith: 'everyone'
                })
                .then(() => username)
        })
        .then(username => {
            return cloudDB.ref(`public/${username}`)
                .set({path: user.uid})
                .then(() => username);
        })

}

const unshare = (uid, slug) => {
    return cloudDB.ref(`users/${uid}/${slug}`)
        .update({
            sharedWith: null
        })
        .catch(console.error);
}

function setNewUsername(newUsername, uid){
    return cloudDB.ref(`public/${newUsername}`).once('value')
        .then(snapshot => {
            if(snapshot.exists()){
                // Throw an error
                throw new Error("Username taken");
            }

            return;
        })
        .then(() => {
            return cloudDB.ref(`public/${newUsername}`)
                .set({path: uid});
        })
}

const changeUsername = (newUsername, uid, prevUsername=null) => {
    if(prevUsername){
        return setNewUsername(newUsername, uid)
            .then(() => cloudDB.ref(`public/${prevUsername}/path`).remove())
    }

    return setNewUsername(newUsername, uid);
}

export default {
    getAllData,
    getNotebook,
    deleteNotebook,
    addNotebook,
    addContent,
    setAutoSave,
    getAddressToBookNode,
    makeShareable,
    unshare,
    getUsername,
    changeUsername
}